export function getAIAnalysisErrorMessage(error: unknown): string {
  const details = error && typeof error === 'object' ? error as Record<string, unknown> : {}
  const status = details.status || details.statusCode
  if (details.code === 'functions/unauthenticated')
    return '로그인 후 AI 분석을 이용해주세요.'
  if (details.code === 'functions/invalid-argument')
    return 'AI 분석 내용을 확인해주세요. 분석 내용은 20~12000자 이내여야 합니다.'
  if (status === 429 || details.code === 'functions/resource-exhausted')
    return 'AI 분석 서비스의 사용량 한도 또는 잔액이 부족합니다. 관리자에게 문의해주세요.'
  if (status === 401 || status === 403 || details.code === 'functions/failed-precondition')
    return 'AI 분석 서비스 인증 설정을 확인해야 합니다. 관리자에게 문의해주세요.'
  if (details.name === 'AbortError' || details.name === 'TimeoutError' || details.code === 'functions/deadline-exceeded')
    return 'AI 분석 응답 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.'
  return 'AI 분석을 완료하지 못했습니다. 잠시 후 다시 시도해주세요.'
}

export function parseAIAnalysis(content: string): { keywords: string[] } {
  const result: unknown = JSON.parse(content)
  if (!result || typeof result !== 'object' || !('keywords' in result)
    || !Array.isArray(result.keywords) || result.keywords.length < 8 || result.keywords.length > 15
    || !result.keywords.every((word: unknown) => typeof word === 'string' && word.trim().length > 0)) {
    throw new Error('AI analysis returned invalid keywords.')
  }
  return { keywords: result.keywords }
}
